import type { OptionsDocument, Payment } from 'paintscout'
import moment from 'moment'
import { formatCurrency } from '../../util/format-currency'

export function formatProcessingPaymentBullet({
  options,
  payment
}: {
  options: OptionsDocument
  payment: Payment
}): string {
  const dateFormat = options.options.dateFormat?.momentValue ?? 'MMM D, YYYY'
  const parts = [
    formatCurrency({ options, value: payment.amount }),
    payment.type ?? null,
    payment.date ? moment(payment.date).format(dateFormat) : null
  ].filter(Boolean)
  return parts.join(' · ')
}
